export function secondsSinceEvent(timestampInSeconds: number) {
  const date = new Date(timestampInSeconds * 1000);
  const eventDateSeconds = Math.floor(date.getTime() / 1000.0);
  const now = Math.floor(new Date().getTime() / 1000.0);
  const diffInSeconds = Math.floor(now - eventDateSeconds);
  if (diffInSeconds >= 60) {
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes === 1) {
      return "1 minute ago";
    } else {
      return diffInMinutes.toFixed(0) + " minutes ago";
    }
  } else if (diffInSeconds <= 0) {
    return "Just now";
  } else {
    return diffInSeconds.toFixed(0) + " seconds ago";
  }
}
